import { DefaultTransactionColumnHeader } from "./DefaultTransactionColumnHeader";
import { TransactionColumn } from "./TransactionColumn";
import { TransactionColumnSizer } from "./TransactionColumnSizer";
import { TransactionColumnFilterTags } from "./TransactionColumnFilterTags";

export function TransactionColumnHeaderTags(): JSX.Element {
  return (
    <TransactionColumnSizer column={TransactionColumn.TAGS}>
      <DefaultTransactionColumnHeader
        column={TransactionColumn.TAGS}
        text={"Tags"}
        FilterType={TransactionColumnFilterTags}
      />
    </TransactionColumnSizer>
  );
}
